module.exports = __webpack_public_path__ + "media/images/icons/country_flags/np-04984547fd38cbe44c74242814ce630b.svg";